import type { Venda } from "./api";
import { normalizeSearchText } from "./searchText";

export function vendaMatchesAtendimento(atendimento: Venda["atendimento"], busca: string): boolean {
  const query = normalizeSearchText(busca.trim());
  if (!query) return true;
  if (!atendimento) return false;
  // Numeros sao tokens completos: 2 nunca encontra 12 ou 20.
  const numeros = query.match(/\d+/g) ?? [];
  const numero = atendimento.numero;
  if (atendimento.tipo === "ambos") {
    const comanda = atendimento.numero_comanda ?? numero;
    const mesa = atendimento.numero_mesa ?? "";
    if (numeros.some((n) => n !== comanda && (mesa === "" || n.replace(/^0+/, "") !== mesa.replace(/^0+/, "")))) return false;
    return query.replace(/\d+/g, " ").replace(/[·:-]/g, " ").split(/\s+/).filter(Boolean)
      .every((part) => normalizeSearchText(atendimento.identificacao).includes(part));
  }
  if (numeros.some((n) => atendimento.tipo === "mesa"
    ? n.replace(/^0+/, "") !== numero.replace(/^0+/, "")
    : n !== numero)) return false;
  const texto = query.replace(/\d+/g, " ").replace(/\s*-\s*/g, " ").trim();
  const identificacao = normalizeSearchText(atendimento.identificacao).replace(/\d+/g, " ").replace(/\s*-\s*/g, " ");
  return texto.split(/\s+/).filter(Boolean).every((parte) => identificacao.includes(parte));
}
